var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoy = function SvgBoy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "boy-waving",
    viewBox: "-40 0 260 393.71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "body"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ears"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "ear",
    cx: 503.56,
    cy: 324.29,
    rx: 13.67,
    ry: 17,
    transform: "translate(-400.56 -164.49) rotate(-7)",
    style: {
      fill: "#fab27f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ear",
    cx: 385.21,
    cy: 324.32,
    rx: 13.67,
    ry: 17,
    transform: "translate(-370.49 -221.36) rotate(-1.01)",
    style: {
      fill: "#fab27f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "idle-arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arm-left",
    d: "M432.26,387.65a10,10,0,0,0-13.78-3.18c-.6.37-14.87,9.4-28.29,26.87a121.2,121.2,0,0,0-23.43,54.5c-2,13.19-5.65,44.05,8.69,52.64,14.66,8.8,15.81-9.24,13.58-18.63,9.13,8.12,12.12,2.3,7.75-6.23-6.35-12.37-11.75-16.34-8.8-31.26a94.52,94.52,0,0,1,17.63-38.27,102.33,102.33,0,0,1,23.49-22.68A10,10,0,0,0,432.26,387.65Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#fcc697"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "jacket-sleeve-left",
    d: "M425.68,400.41l-.32-.62c-.4-.71-.8-1.42-1.19-2.13a123.43,123.43,0,0,1-7.61-12.1,124.84,124.84,0,0,0-26.05,25.35,121.29,121.29,0,0,0-23.42,54.5c-.25,1.63-.52,3.52-.79,5.61,7.07-.21,14.15.11,21.24.21a35.23,35.23,0,0,1,.77-9.3,94.25,94.25,0,0,1,17.63-38.27,107.13,107.13,0,0,1,20.81-20.79Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#3b2c25"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "wave-arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arm-right",
    d: "M461.61,397.53a10,10,0,0,0,12.49,6.64c.68-.21,16.79-5.23,34.28-18.64A121.28,121.28,0,0,0,545.11,339c5.38-12.21,16.86-41.08,5.24-53.1-11.89-12.29-17.67,4.84-17.94,14.48-6.72-10.2-11.12-5.35-9.1,4,2.93,13.59,7.13,18.82.41,32.47a94.27,94.27,0,0,1-26.94,32.4,102,102,0,0,1-28.56,15.83A10,10,0,0,0,461.61,397.53Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#fcc697"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "jacket-sleeve-right",
    d: "M471.7,386.57l.15.69.6,2.36a125.28,125.28,0,0,1,4.21,13.66,125.19,125.19,0,0,0,31.72-17.75A121.28,121.28,0,0,0,545.11,339c.67-1.51,1.42-3.27,2.22-5.22-6.89-1.62-13.65-3.76-20.46-5.69a35.69,35.69,0,0,1-3.15,8.78,94.27,94.27,0,0,1-26.94,32.4,107.26,107.26,0,0,1-25.48,14.7C471.43,384.8,471.56,385.69,471.7,386.57Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#3b2c25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "neck",
    d: "M476,388.25c-4.94-5.39-21.75-13.52-30.58-11.15-8.82-2.37-25.63,5.76-30.57,11.15-7.29,7.95-16.31,21.7-14.25,86.7h89.64C492.29,410,483.28,396.2,476,388.25Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#f29556"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "face-base",
    d: "M486.4,274c-11-7.51-25.25-11.64-40-12.48v-.06l-.51,0-.51,0h0v.06c-14.77.84-30,5-41,12.48-16.57,11.31-21.1,34.79-20.24,53,2.56,54.75,45.9,57.61,61.22,58.79v.08l.87,0,.15,0v0c46.51-.07,56.72-34.39,58.23-58.85C505.76,308.75,503,285.26,486.4,274Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#fcc697"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "smile",
    d: "M459,355a3,3,0,0,0-3.35,2.58c-.11.78-1.33,7-10.19,7.4-8.86-.43-10.08-6.62-10.19-7.4a3,3,0,0,0-6,.77c.54,4.34,4.62,12.11,16,12.6v0h.34v0c11.35-.49,15.43-8.26,16-12.6A3,3,0,0,0,459,355Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#f29556"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nose",
    d: "M454.74,342.28c0,3.5-2.33,6.33-5.21,6.33h-8.24c-2.88,0-5.21-2.83-5.21-6.33h0c0-3.5,2.33-6.33,5.21-6.33h8.24c2.88,0,5.21,2.83,5.21,6.33Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#f29556"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "legs",
    d: "M400.71,474c1.12,11.6,7.47,74.74,22.75,126h16l-3-88h18.05l-3,87h16c14.89-49.92,21.3-111.27,22.66-125Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#fab27f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "eyes-left",
    cx: 50.48,
    cy: 99.87,
    r: 6.49,
    style: {
      fill: "#343431"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "eyes-right",
    cx: 110.72,
    cy: 99.87,
    r: 6.49,
    style: {
      fill: "#343431"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hair-base",
    d: "M506.59,293.26A56.73,56.73,0,0,0,504,277.93a40.1,40.1,0,0,0-26-25.81c-10.17-3.29-54.92-3-65.09.31a40.1,40.1,0,0,0-26,25.81,56.42,56.42,0,0,0-2.64,15.34c-.2,5.23,2.66,16.66,2.66,16.66,3.34-19.33,12.57-23.92,26.65-22.66,11.85,1.05,20,7.2,32.58,6.56,0-.09,0-.19,0-.29,11.81.15,19.78-6,31.22-6.59,18.86-1,28,22,28,22A56.12,56.12,0,0,0,506.59,293.26Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#3b2c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hair-top",
    d: "M386.8,276.91c14.83-30.08,42.72-33.23,70.67-45.48,7.07-3.1,7.89-5.4,14.52.28a106.83,106.83,0,0,1,32.81,50.53",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#3b2c25"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "clothes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "shoes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shoe-main",
    d: "M439.46,600h-16s-27,14-25,22h42Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#17242c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shoe-main",
    "data-name": "shoe-main",
    d: "M451.36,599h16s27,14,25,22h-42Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#17242c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shoe-side",
    d: "M427.69,621h12.77l-.81-17.84C433.8,607.33,430.07,614,427.69,621Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#4198c5",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shoe-side",
    "data-name": "shoe-side",
    d: "M463.13,621H450.35l.81-17.84C457,607.33,460.75,614,463.13,621Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#4198c5",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shoe-sole",
    d: "M400.82,616c-1.81,2.15-2.8,4.22-2.36,6h42l-.27-6Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#716966"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shoe-sole",
    "data-name": "shoe-sole",
    d: "M450.59,617l-.23,5h42c.37-1.5-.27-3.21-1.57-5Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#716966"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "pants",
    d: "M490.18,474H400.71c1.07,11.05,6.88,68.89,20.65,118.66h-2.51v8.67h22.66v-8.67h-2.3L436.46,512h18.05l-2.78,81h-2.22v8.66h22.67V593h-2.93C482.91,544.23,488.87,487.13,490.18,474Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#c56d41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shirt",
    d: "M476,387.25c-.58-.62-.31-.28-1.17-1-17.42,12.53-41.69,13.87-59.28-.74-.25.24-.49.47-.7.7-7.29,7.95-16.31,23.7-14.25,88.7h89.64C492.29,410,483.28,395.2,476,387.25Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#ff5249"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "jacket"
  }, /*#__PURE__*/React.createElement("path", {
    className: "jacket-outer",
    d: "M490.71,471.81c3.48-64.32-6.21-76.15-13.4-84-.57-.62-2.3-1.28-3.15-1.95-.8,28.71-3.16,57.32-5.31,85.94H422.19c-3.54-27.69-6.39-57.21-7.95-85-7,8.09-17.58,23.35-13.45,85.88v12.42h91.34V471.81Z",
    transform: "translate(-364.81 -228.23)",
    style: {
      fill: "#3b2c25"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "jacket-inner"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61.65 148.91 36.32 154.91 53.32 244.91 62.98 244.91 61.65 148.91",
    style: {
      fill: "#4d4039"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.65 148.91 124.98 154.91 107.98 244.91 98.32 244.91 99.65 148.91",
    style: {
      fill: "#4d4039"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boy.124531b8.svg";
export { ForwardRef as ReactComponent };